import { render, staticRenderFns } from "./ConnectionsHistoryFilter.vue?vue&type=template&id=b839358e&scoped=true"
import script from "./ConnectionsHistoryFilter.vue?vue&type=script&lang=js"
export * from "./ConnectionsHistoryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b839358e",
  null
  
)

export default component.exports